<template>
  <div class="s-d-p">
    <el-date-picker class="s-d-p-d" ref="datePick" @change="chooseDate" @blur="chooseDate" v-model="dateValue"
      type="date" popper-class="d-icon" placeholder="请选择日期">
    </el-date-picker>
  </div>
</template>

<script>
export default {
  name: "ShouDatePicker",
  data() {
    return {
      dateValue: '',
      timeoutId: null
    }
  },
  mounted() {
    this.$refs.datePick.focus(); // 让日历组件默认触发焦点事件
  },
  methods: {
    chooseDate() {
      this.$refs.datePick.focus(); // 选择日期后依旧触发焦点

      if (this.timeoutId) {
        return;
      }

      this.timeoutId = setTimeout(() => {
        this.$emit('changePicker', this.dateValue);
        this.timeoutId = null;
      }, 100);
    }
  },
}
</script>

<style lang="scss" scoped>
.s-d-p {
  position: relative;
  overflow: hidden;
  width: 324px;
  height: 341px;
  background: #fff;
  border-radius: 4px;

  .s-d-p-d {
    position: absolute;
    top: -52px;
  }
}
</style>

<style>
.d-icon .popper__arrow {
  display: none;
}
</style>